<micro-lookup domain="sms" obj="anumbers" url="/sms/anumbers" [key]="anumberId" [link]="link"></micro-lookup>
